import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { useProvider } from "@/contexts/ProviderContext";
import { fetchJotformPlanSettings } from "@/services/jotformPlanService";

export function useJotformPlanMatch() {
  const { user } = useAuth();
  const { connectionStatus } = useProvider();

  return useQuery({
    queryKey: ["jotformPlanMatch", user?.id || null],
    queryFn: fetchJotformPlanSettings,
    enabled: Boolean(user) && connectionStatus.jotform === true,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
